export default () => ({
    hasRequiredFitmentChanged: false,
    defaultSelectTypes: null,
    requiredSelectTypes: [],
    optionalSelectTypes: [],
    data: {},
    modal: {
        selects: [],
        isFitsMode: false,
        isSameDayShippingMode: false,
        isMMYMode: false,
        isStoppingInit: false, // this is needed especially when going back/forward when your YMM changes.  we need to stop the filling of the drills and start over!!
    },
})
